import React, { ReactElement } from 'react';
import {
  IconInfoCircledComponent,
  Nullable,
  useTheme,
  useTranslations,
} from '@lerna-core';
import { TooltipContainer } from '@features/common/tooltip';
import * as S from './onlinePaymentPriceItem.styled';
import { PricesItemContainerProps } from './onlinePaymentPriceItem.model';

export const OnlinePaymentPriceItemContainer = ({
  value,
  percent,
  isNegative,
}: PricesItemContainerProps): Nullable<ReactElement> => {
  const theme = useTheme();
  const translations = useTranslations();
  const tooltipText = percent
    ? translations.online_pay_discount_tooltip_text.replace(
        '{{DISCOUNT}}',
        percent
      )
    : undefined;

  if (!value) return null;

  return (
    <S.OnlinePaymentPriceItem>
      <S.Title>
        {translations?.online_pay_discount_label}
        <div>
          {`- ${percent}`}
          {!!tooltipText && (
            <TooltipContainer
              content={tooltipText}
              contentPosition="left"
              triggerHoverOpacity={0.64}
              contentMargin="4px -75px 0 0"
              triggerMargin="0 0 0 4px"
            >
              <IconInfoCircledComponent
                width={16}
                height={16}
                strokeColor={theme.COLOR.TEXT_DARK_COLOR}
                fillColor={theme.COLOR.TEXT_DARK_COLOR}
              />
            </TooltipContainer>
          )}
        </div>
      </S.Title>
      <S.Value>
        {isNegative && '-'} {value}
      </S.Value>
    </S.OnlinePaymentPriceItem>
  );
};
